<div *ngFor="let attachment of attachmentsData" class="mt-1">
    <em class="blue-color cursor-pointer" (click)="downloadAttachment(attachment.fileId, attachment.attachmentName)"
      ><app-file-icon [fileType]="attachment.attachmentType"></app-file-icon
    ></em>
    <span class="ml-3">{{ attachment.attachmentPath }}</span>
  </div>
  